/**
 * Whether the native bridge has finished reading its session token from the
 * token vault (P1-12, auth-token-persistence.ts).
 *
 * Until it has, a request goes out without the token and answers 401. That
 * 401 says nothing about the session, so the API client must not sign the
 * responder out for it (services/api.ts). The web console never hydrates, so
 * it is always 'settled' there.
 *
 *   settled   the vault was read (or this is the web console)
 *   pending   the vault read is in progress (start-up may render before it ends)
 *   deferred  the vault answered with a transient error (Keystore busy); the
 *             persisted session is kept and the read is retried
 *
 * Kept in its own module so the API client can read it without importing the
 * Capacitor storage plugins.
 */
export type NativeAuthHydrationState = 'settled' | 'pending' | 'deferred';

let state: NativeAuthHydrationState = 'settled';

export function getNativeAuthHydrationState(): NativeAuthHydrationState {
  return state;
}

export function setNativeAuthHydrationState(next: NativeAuthHydrationState): void {
  state = next;
}

/** False while a 401 may only mean "the token has not been read yet". */
export function isNativeAuthHydrationSettled(): boolean {
  return state === 'settled';
}
